import React from "react";
import { Button } from 'reactstrap'
import BloqueioBlService from "../../../services/BloqueioBlService";
import { observable, toJS } from "mobx";
import { IconeDelete, sortCaret } from "../../comum/components/Icones";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../utils/mensagens";
import { formatarDataCustomHTML, appendFieldSpan } from "../../../utils/formatar"



export default class BloqueioBlStore {
    
    @observable bls;
    @observable operacoes;
    @observable operacaoEscolida;
    @observable operacaoEscolidaNovoBloqueio
    @observable numBl;
    @observable numBlNovo;
    @observable novoBloqueio;
    @observable isEditando;
    @observable bloqueios;
    @observable mensagens;
    @observable mensagemErro;
    @observable modalConfirmaApagar;
    @observable clickFiltrar;
    @observable tableMessage;
    @observable colunas;
    @observable itemDeletar;
    @observable salvando;
    @observable apagando;
    @observable itens;
    @observable hasMore;
    @observable loading;

    constructor(){
        this.blservice = new BloqueioBlService()

        this.operacoes = [];
        this.bloqueios = [];
        this.mensagens = [];
        this.itens = [];
        this.toShow = 20;
        this.turn = 0;
        this.hasMore = false;
        this.loading = false;
        this.operacaoEscolida = null;
        this.operacaoEscolidaNovoBloqueio = null;
        this.itemDeletar = null;
        this.novoBloqueio = false;
        this.isEditando = false;
        this.clickFiltrar = false;
        this.modalConfirmaApagar = false;
        this.salvando = false;
        this.apagando = false;
        this.numBlNovo = "";
        this.numBl = "";
        this.mensagemErro = "";
        this.colunas = this.todasColunas;
        this.tableMessage = buscaFiltrarVazio;

        this.addAcoesColNovas()

    }

    showAdicionarBloqueio = () => {
        this.novoBloqueio = true
    }

    hideAdicionarBloqueio = () => {
        if(this.isEditando){
            this.isEditando = false
        }else{
            this.novoBloqueio = false
        }
    }

    getLista() {
        return this.bloqueios;
    }

    getListaCopia() {
        return toJS(this.bloqueios)
    }

    cleanNovoBloqueio = () => {
        this.operacaoEscolidaNovoBloqueio = null
        this.numBlNovo = ""
    }

    editarDadosBloqueio = () => {
        const opEscolida = this.operacoes.find(op => op.value === this.isEditando.IdOperacao)
        this.operacaoEscolidaNovoBloqueio = opEscolida
        this.numBlNovo =  this.isEditando.NumeroBl
    }

    listarBls = () => {
        const opEscolida = this.operacaoEscolida ? this.operacaoEscolida.value : ""

        this.loading = true
        this.blservice.Listar(this.numBl,opEscolida).then(response => {
            if(response && response.data){
                this.bloqueios = response.data
                this.loadFirstTurn()
                if(response.data.length === 0) this.tableMessage = buscaSemResultado
            }
        }).catch(err => console.log(err)
        ).finally(() => this.loading = false)
    }

    loadFirstTurn = () => {
        this.itens = this.bloqueios.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.bloqueios.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.bloqueios.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.itens.length < this.bloqueios.length;
    };

    listarOperacoes = () => {
        this.blservice.ListarOperacao().then(response => {
            if(response && response.data){
                response.data.map(dado => {
                    this.operacoes.push({label: dado.NomeNavioAndCodNavioAndCodViagem ,value: dado.IdOperacao})
                })
            }
        }).catch(err => console.log(err))
    }

    inserirBloqueio = () => {
        this.salvando = true
        this.mensagemErro = ""
        const opEscolida = this.operacaoEscolidaNovoBloqueio ? this.operacaoEscolidaNovoBloqueio.value : ""
        this.blservice.Inserir(this.numBlNovo,opEscolida).then(response => {
            if(response && response.data){
                if(response.data.Sucesso){
                    this.mensagens.push(response.data.Mensagem)
                    if(this.clickFiltrar) this.listarBls()
                }else{
                    this.mensagemErro = response.data.Mensagem
                }
                if(response.data.Sucesso && this.clickFiltrar) this.listarBls()
            }
        }).catch(err => console.log(err)
        ).then(() => {
            if(this.mensagens.length > 0) this.hideAdicionarBloqueio()
            this.salvando = false
        })
    }

    editarBloqueio = () => {
        this.salvando = true
        this.isEditando.NumeroBl = this.numBlNovo
        this.isEditando.IdOperacao = this.operacaoEscolidaNovoBloqueio ? this.operacaoEscolidaNovoBloqueio.value : ""
        this.blservice.Editar(this.isEditando).then(response => {
            if(response && response.data){
                if(response.data.Sucesso){
                    this.mensagens.push(response.data.Mensagem)
                    if(this.clickFiltrar) this.listarBls()
                }else{
                    this.mensagemErro = response.data.Mensagem
                }
            }
        }).catch(err => console.log(err)
        ).then(() => {
            if(this.mensagens.length > 0) this.hideAdicionarBloqueio()
            this.salvando = false
        })
    }

    confimarApagarBloqueio(row){
        this.modalConfirmaApagar = true
        this.itemDeletar = row
    }

    cancelarApagarBloqueio(){
        this.modalConfirmaApagar = false
        this.itemDeletar = null
    }

    apagarBloqueio = () => {
        this.apagando = true
        const bl = {
            "ArmArmId": null,
            "BlBloqId": this.itemDeletar.BlBloqId,
            "CdNavio": null,
            "CodViagem": null,
            "DataInclusao": null,
            "IdOperacao": null,
            "NomeNavio": null,
            "NumeroBl": null,
            "NviCdNavio": null,
            "Operacao": null,
            "Operconcat": null,
            "Situacao": this.itemDeletar.Situacao,
            "TipoViagem": null,
            "UsuarioInclusao": null
        }
        this.blservice.Excluir(bl).then(response => {
            if(response && response.data){
                this.mensagens.push(response.data.Mensagem)
                if(response.data.Sucesso && this.clickFiltrar) this.listarBls()
            }
        }).catch(err => console.log(err)
        ).then(()=>{
            this.apagando = false
            this.itemDeletar = null
            this.modalConfirmaApagar = false
            if(this.clickFiltrar) this.listarBls()
        })
    }

    addAcoesColNovas = () => {
        this.colunas.push({
            dataField: 'acoes',
            isDummyField: true,
            text: 'Ação',
            formatter: (cell, row) => {
                return <div>
                    <Button onClick={ () => this.abrirEditar(row) } className="btn-acoes btn-com-bordas-cinza">Editar</Button>
                </div>
            }
        });
        this.colunas.push({
            dataField: 'excluir',
            isDummyField: true,
            text: 'Excluir',
            align: (cell, row, rowIndex, colIndex) => 'center',
            formatter: (cell, row) => {
                return <div>
                    <IconeDelete className="" tamanho="2x" onClick={() => this.confimarApagarBloqueio(row)} />
                </div>
            }
        });
    };

    abrirEditar = (row) => {
        this.isEditando = row
    }

    onChangeOperacao = (event) => {
        this.operacaoEscolida = event
    }
    
    onChangeOperacaoNovoBloqueio = (event) => {
        if(this.mensagemErro !== "") this.mensagemErro = ""
        this.operacaoEscolidaNovoBloqueio = event
    }

    onChangeFiltroBl = (event) => {
        this.numBl = event.target.value
    } 
    
    onChangeBlNovoBloqueio = (event) => {
        if(this.mensagemErro !== "") this.mensagemErro = ""
        if(!event){
            this.numBlNovo = null
            //fazer verificação de obrigatoriedade no campo
        }else{
            this.numBlNovo = event.target.value.toUpperCase()
        }
    } 

    todasColunas = [
        {
            dataField: "NumeroBl",
            text: "BL",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "NomeNavio",
            text: "Operação",
            sort: true,
            formatter: appendFieldSpan,
            formatExtraData: "IdOperacao",
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "DataInclusao",
            text: "Inclusão",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "UsuarioInclusao",
            text: "Criador",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
    ]
}


// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/stores/BloqueioBlStore.js